import { Alert } from 'types/alert';

export const initialState: MainState = {
  alerts: [],
  isManualInputHidden: true
};

export interface MainState {
  alerts: Alert[];
  isManualInputHidden: boolean;
}


// WEBPACK FOOTER //
// ./src/components/main/state.ts